import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';

const getNotifications = ({
  name,
  created_by,
  type,
  status,
  category,
  limit,
  page,
  sort,
  sortBy,
},) => {
  const query = {
    name: name || undefined,
    created_by: created_by || undefined,
    type: type || undefined,
    status: status || undefined,
    category: category || undefined,
    sort: `${sort == 'desc'? '-': ''}${sortBy}`,
    limit: limit || '20',
    page: page || '1',
  };

  const qsConfig = qs.stringify(
    query,
    { addQueryPrefix: true, },
  );
  return BaseHttp.get(`/notifications${qsConfig}`,);
};

export default {
  getNotifications,
};
